import { PageType } from "components/server-types";
import { selectAssessedSubmissionsByTopicId } from "store/selectors";
import { useListSelector } from "store/store-hooks";

export const useCanDeleteActions = (
  topicId: string,
  pages?: Pick<PageType, "id" | "activity_id">[],
) => {
  const assessedSubmissions = useListSelector(
    (s) => selectAssessedSubmissionsByTopicId(s, topicId),
    ["page_id"],
  );
  const assessedPageIds = new Set(assessedSubmissions.map((submission) => submission.page_id));

  const assessedActivityIds = new Set<string>();
  if (pages) {
    for (const page of pages) {
      if (page.activity_id && assessedPageIds.has(page.id)) {
        assessedActivityIds.add(page.activity_id);
      }
    }
  }

  return {
    canDeleteActivity: (targetActivityId: string) => !assessedActivityIds.has(targetActivityId),
    canDeleteTopic: !assessedSubmissions.length,
  };
};
